module.exports = __webpack_public_path__ + "static/media/loading.7e1a0e07.gif";